/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';

import { getUpcomingEventsByIdAsync } from '../../actions/DataActionExtension.g';
import { GetCurrentEventInput } from '../../actions/ecomm-current-event';

import { IEcommEventDescriptionData } from './ecomm-event-description.data';
import { IEcommEventDescriptionProps } from './ecomm-event-description.props.autogenerated';

export interface IEcommEventDescriptionViewProps extends IEcommEventDescriptionProps<IEcommEventDescriptionData> {
    type: string;
    name: string;
    imageUrl: string;
    description: string;
}

/**
 *
 * EcommEventDescription component
 * @extends {React.PureComponent<IEcommEventDescriptionProps<IEcommEventDescriptionData>>}
 */
class EcommEventDescription extends React.PureComponent<IEcommEventDescriptionProps<IEcommEventDescriptionData>> {
    public state = { event: '' };

    public componentDidMount() {
        if (typeof window !== 'undefined') {
            const {
                config,
                context,
                data: { categories }
            } = this.props;

            const parameters = window.location.search;
            const urlParams = new URLSearchParams(parameters);
            const eventId = urlParams.get('id');

            const language = context.request.locale.split('-')[0];
            const org = config.organisation ? this.props.config.organisation! : 'BT';

            const startDate = new Date();
            startDate.setHours(0, 0, 0, 0);

            const endDate = new Date();
            endDate.setHours(0, 0, 0, 0);
            endDate.setMonth(endDate.getMonth() + config.dateRange);

            // Get event from api.
            void getUpcomingEventsByIdAsync(
                { callerContext: context.actionContext },
                config.isUat,
                language,
                org,
                startDate.toISOString(),
                endDate.toISOString(),
                eventId ? eventId : ''
            ).then(result => {
                if (result.length > 0 && this.state.event === '') {
                    const eventJson = JSON.parse(result[0]);

                    if (eventJson['EcommerceId']) {
                        var categoryIndex = categories.result!.findIndex(
                            category => category.RecordId.toString() === eventJson['EcommerceId']
                        );

                        if (categoryIndex >= 0) {
                            var imgUrl = generateImageUrl(
                                categories.result![`${categoryIndex}`].Images![0].Uri,
                                this.props.context.request.apiSettings
                            );
                            eventJson['Img'] = imgUrl;
                        }

                        context.actionContext.update(new GetCurrentEventInput(), {
                            eventJson: result[result.length - 1]
                        });
                    }

                    this.setState({ event: JSON.stringify(eventJson) });
                }
            });
        }
    }

    public render(): JSX.Element | null {
        if (!this.state.event) {
            return null;
        }

        const item = JSON.parse(this.state.event);

        const IEcommEventDescriptionViewProps = {
            ...this.props,
            type: item.Type,
            name: item.Name,
            imageUrl: item.Img,
            description: item.Description
        };

        return this.props.renderView(IEcommEventDescriptionViewProps);
    }
}

export default EcommEventDescription;
